import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { AliaBackendService } from '@customization/alia-backend.service';
import { DeliveryPoint } from '@customization/models/delivery-point.model';
import { Department } from '@customization/models/department.model';
import { SelectDepartmentJson } from '@customization/models/select-department-json.model';
import { TranslocoService } from '@ngneat/transloco';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import it from './i18n/select-department-session.it.json';

@Component({
  templateUrl: './select-department-session.component.html',
  styles: [
  ]
})
export class SelectDepartmentSessionComponent {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  deliveryPoint$ = this.aliaSvc.getDeliveryPoint();

  deliveryPointSearchFn = (name?: string) => this.deliveryPoint$.pipe(
    map(dps => name ? dps.filter(dp => this.deliveryPointLabelFn(dp).toLowerCase().indexOf(name.toLowerCase()) > -1) : dps)
  );
  deliveryPointLabelFn = (dp: Partial<DeliveryPoint>) => `${dp.CODICE_PUNTO_CONSEGNA} - ${dp.DESCRIZIONE}`;

  inputForm = this.fb.group({
    deliveryPoint: [undefined, [Validators.required]],
    department: [undefined,[Validators.required]],
  });

  private deliveryPointLabel$$ = new BehaviorSubject<string>('');
  deliveryPointLabel$ = this.deliveryPointLabel$$.asObservable();

  private departmentLabel$$ = new BehaviorSubject<string>('');
  departmentLabel$ = this.departmentLabel$$.asObservable();

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService,
    private aliaSvc: AliaBackendService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  selectDeliveryPoint(dp: Partial<DeliveryPoint> | null | string | number) {
    let departments: (Department | Partial<Department>)[] = [];
    if (dp) {
      const deliveryPoint = dp as DeliveryPoint;
      departments = deliveryPoint.REPARTI;
    }
    const department = departments.length === 1 ? departments[0] : undefined;
    this.inputForm.patchValue({
      department
    });
  }

  submit(form: FormGroup) {
    if (form.valid) {
      const {deliveryPoint, department} = form.value;
      const dp = (deliveryPoint as DeliveryPoint);
      const d = (department as Department);

      const json: SelectDepartmentJson = {
        input: {
          deliveryPointCode: dp?.CODICE_PUNTO_CONSEGNA,
          deliveryPointName: dp?.DESCRIZIONE,
          departmentCode: d?.CODICE_REPARTO,
          departmentName: d?.DESCRIZIONE,
        }
      };
      const now = DateTime.local();
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now.toJSDate(),
        type: SessionStepValueType.inputObject,
        value: json
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now.toJSDate(), values: [value] });
    }
  }

}
